<template>
	<v-dialog  
	 	v-model="dialog"
		:fullscreen="fullscreen"
		transition="dialog-bottom-transition"
		scrollable
		persistent
		:max-width="maxWidth"
	>
		<template v-slot:activator="{ on: dialog, attrs }">
			<slot name="activator" :attrs="attrs" :dialog="dialog">
				<v-tooltip bottom>
					<v-btn icon v-bind="attrs" v-on="{ ...dialog }">
						<v-icon>mdi-pencil</v-icon>
					</v-btn>
					<span>{{ $vuetify.lang.t(`$vuetify.${tooltip}`) | capitalize }}</span>
				</v-tooltip>
			</slot>
		</template>

		<v-card>
			<v-toolbar flat dark color="primary" style="flex: 0 1 auto;">
				<v-avatar>
					<v-icon>{{ icon }}</v-icon>
				</v-avatar>
				<v-toolbar-title>{{ title }}</v-toolbar-title>
				
				<v-spacer></v-spacer>

				<!-- <v-btn icon @click="onSave" >
					<v-icon>mdi-content-save</v-icon>
				</v-btn> -->

				<!-- <v-divider vertical></v-divider> -->

				<v-btn icon @click="fullscreen = !fullscreen">
					<v-icon v-if="fullscreen">mdi-arrow-collapse</v-icon>
					<v-icon v-else="fullscreen">mdi-arrow-expand</v-icon>
				</v-btn>
				<v-btn icon @click="dialog=false" >
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-card-text>
				<v-form ref="form">
					<v-row class="mt-3" dense>
						<v-col cols="12" md="9">
							<v-text-field
								:label="$vuetify.lang.t('$vuetify.name') | capitalize"
								v-model="item.name"
								clearable
								outlined
								dense
								hide-details="auto"
								:rules="[rules.required]"
							></v-text-field>
						</v-col>
						<v-col cols="12" md="3">
							<v-text-field
								:label="$vuetify.lang.t('$vuetify.code') | capitalize"
								v-model="item.code"
								clearable
								outlined
								dense
								hide-details="auto"
							></v-text-field>
						</v-col>
						<v-col cols="12">
							<z-type
								v-model="item.type"
								label="Тип"
								:defaultIndex="0"
								outlined
								dense
								hide-details="auto"
							></z-type>
						</v-col>
						<!-- <v-col cols="12" md="3">

						</v-col> -->
						<v-col cols="12">
							<v-textarea
								v-model="item.description"
								:label="$vuetify.lang.t('$vuetify.comment') | capitalize"
								hint=""
								rows="2"
								outlined
								dense
								hide-details="auto"
							></v-textarea>
						</v-col>

						<v-col cols="12" md="6">
							<z-state
								v-model="item.state"
								label="Область"
								outlined
								dense
								hide-details="auto"
								clearable
								:rules="[rules.ChoiceOrEmpty]"
							></z-state>
						</v-col>
						<v-col cols="12" md="6">
							<z-city
								v-model="item.city"
								:state="item.state"
								label="Місто"
								outlined
								dense
								hide-details="auto"
								clearable
							></z-city>
						</v-col>
						<v-col cols="12">
							<z-marketregion
								v-model="item.marketregion"
								label="Ринок регіону"
								outlined
								dense
								hide-details="auto"
								clearable
							></z-marketregion>
						</v-col>
						<v-col cols="12" md="6">
							<v-text-field
								label="Пробіг, тис.км"
								v-model="item.mileage"
								outlined
								dense
								type="number"
								hide-details="auto"
							></v-text-field>
						</v-col>
						<v-col cols="12" md="6">
							<v-text-field
								label="Коефіцієнт торгу"
								v-model="item.bargain"
								outlined
								dense
								type="number"
								hide-details="auto"
							></v-text-field>
						</v-col>
						<v-col cols="12" v-if="assessmentPeriodVisible">
							<v-text-field
								label="Період оцінки, днів"
								v-model="item.assessmentPeriod"
								outlined
								dense
								type="number"
								hide-details="auto"
							></v-text-field>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click.native="onCancel">{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn>
				<v-btn color="success" dark @click.native="onOK" :disabled="loading">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
			</v-card-actions>
		</v-card>

		<!-- <v-snackbar v-model="snackbar.visible" :timeout="snackbar.timeout" :color="snackbar.color">
			{{ snackbar.text }}
			<template v-slot:actions>
				<v-btn icon="mdi-window-close" @click="snackbar.visible = false"></v-btn>
			</template>
		</v-snackbar> -->

		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
	</v-dialog>
</template>

<script>
import axios from 'axios'
import mixin from './mixin/main'
import { mapGetters, mapActions } from 'vuex'
import zType from '@/views/components/controls/select/FleetObjectEstimateType'
import zState from '@/views/components/controls/combobox/State'
import zCity from '@/views/components/controls/combobox/City'
import zMarketregion from '@/views/components/controls/select/VehicleMarketRegion'

export default {
	name: 'DialogDetailFleetEstimate',
	//mixins: [mixin],
	components: { zType, zState, zCity, zMarketregion },
	data: () => ({
		dialog: false,
		fullscreen: false,
		loading: false,

		rules: {
			required: (value) => !!value || "Обов'язкове для заповнення",
			//onlyFromList: (v) => (!!v && v?.id > 0 ) || "Необхідно обрати значення зі списку",
			ChoiceOrEmpty: (value) => {
				if (value === null || value === undefined || value === '') {
					return true;
				}

				// 2. Якщо користувач щось ввів, перевіряємо, чи є це значення в масиві items
				//const exists = this.items.includes(value);
				const exists = value?.id > 0;

				// Якщо значення є в списку — все ок, якщо немає — повертаємо текст помилки
				return exists || 'Будь ласка, оберіть значення зі списку або залиште поле порожнім';
			}
		},

		item: {},

		/* select: {
			vehicles: [],
			estimates: [],
		}, */

		//itemPdf: {},

		/* snackbar: {
			visible: false,
			text: null,
			timeout: 2000,
			color: "success"
		}, */
		/* loadings: {
			category: false,
			brand: false,
			model: false,
			year: false,
			type: false,
		}, */
	}),

	props: {
		title: 				{ type: String, default: 'Оцінка' },
		icon: 				{ type: String, default: 'mdi-tag-text' },
		maxWidth: 			{ type: Number, default: 800 },
	},

	computed: {
		id() {
			return this.item?.id ? this.item.id : null
		},

		assessmentPeriodVisible() {
			return this.item?.type?.code === 'ai'
		},
	},

	created () {
		//console.log(this.$options.name, 'created')

		//this.fullscreen = true;

		//this.focusCategory()?.then(() => this.$set(this.item, 'category', this.categories[0]))
		//this.focusType()?.then(() => this.$set(this.item, 'type', this.types[0]))
	},

	methods: {
		//...mapActions('VehiclePark', [ 'find', 'create', 'update', 'setItem' ]),

		onOpen () {
			//console.log(this.$options.name, 'onOpen', 'selected', this.selected)
			this.setItem();
			if(this.selected?.id) {
				this.loading = true
				this.find(this.selected.id).finally(() => (this.loading = false));
			}
		},

		onOK() {
			//console.log(this.$options.name, 'item', this.item)
			if(this.$refs.form.validate()) {
				this.loading = true
				//let p = this.id ? this.update(this.selected) : this.create();
				const p = this.save()
				p.then(()=>{
					this.dialog = false
				}).finally(() => {
					this.loading = false
				});
			}
		},
	},
}
</script>